/**
 * Quality metrics, hard gates and frame ranking — ARCHITECTURE.md §8, §9.
 */
/** §9 — a failed hard gate rejects the frame outright; no score can compensate. */
export const HARD_GATES = [
    'MOTION',
    'GLARE',
    'CARD_OUTSIDE',
    'PERSPECTIVE',
    'EXPOSURE',
    'MIN_PIXELS',
];
/**
 * §11 — runtime blur policy during recording. Calibrated for handheld: a brief blur
 * (refocus, small shake) is tolerated; only a sustained ~1.8s blur discards the take.
 */
export const BLUR_RUNTIME_POLICY = {
    transientMaxMs: 500,
    warnAndRefocusMaxMs: 900,
    atRiskMaxMs: 1_600,
    /** Beyond this the take is discarded and the stage returns to READY. */
    abortAfterMs: 1_800,
};
/** §10 — ready-to-record gate (handheld-friendly). */
export const READY_TO_RECORD_GATE = {
    windowFrames: 10,
    minPassingInWindow: 6,
    minConsecutivePassing: 3,
    countdownMs: 1_000,
};
//# sourceMappingURL=quality.js.map